document.querySelectorAll("form.contact-form__form").forEach((form) => {
  const quoteFields = form.querySelector("[data-quote-fields]");
  const fieldInputs = quoteFields
    ? quoteFields.querySelectorAll("[data-quote-field]")
    : form.querySelectorAll("[data-quote-field]");
  if (!fieldInputs.length) return;

  form.addEventListener("submit", () => {
    const messageField = form.querySelector('textarea[name="contact[body]"]');
    if (!messageField) return;

    const lines = [];
    fieldInputs.forEach((field) => {
      const value = field.value.trim();
      if (!value) return;
      const label = field.getAttribute("data-quote-label") || field.placeholder || "Field";
      lines.push(`${label}: ${value}`);
    });

    if (!lines.length) return;

    const start = "--- Quote Request ---";
    const end = "--- End Quote Request ---";
    const pattern = new RegExp(`\\n?${start}\\r?\\n[\\s\\S]*?\\r?\\n${end}\\r?\\n?`, "");
    let message = messageField.value.replace(pattern, "").trim();
    const block = `${start}\n${lines.join("\n")}\n${end}`;
    messageField.value = message ? `${message}\n\n${block}` : block;
  });
});
